<template>
    
    <div class="list-group-item px-0 dz-processing dz-image-preview dz-success dz-complete">
        <div class="row align-items-center">
            <div class="col-auto">
                <div class="avatar">
                    <div class="loader" v-if="loading"></div>
                    <img data-dz-thumbnail="" class="avatar-img rounded" :src="url || '/img/custom/placeholder.png'" :alt="img.original_name || 'Processing image'">
                </div>
            </div>
            <div class="ml--3 col">
                <h4 data-dz-name="" class="mb-1">{{ img.original_name || 'Processing...' }}</h4>
                <p data-dz-size="" class="small text-muted mb-0" v-if="meta && meta[0]">
                    {{ meta[0]["MIMEType"] }} / {{ meta[0]["FileSize"] }} / {{ meta[0]["ImageWidth"] }}x{{ meta[0]["ImageHeight"] }} / {{ meta[0]["XResolution"] }}dpi
                </p>
                <p v-if="loading" class="text-info">analyzing...</p>
                <p v-else-if="img && img.processing" class="text-warning">processing image...</p>
                <p v-else-if="!meta" class="text-warning">waiting for analysis...</p>
            </div>
            <div class="col-auto">
                <button data-dz-remove="true" type="button" class="btn btn-danger btn-sm" @click="delete_image">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>
    </div>

</template>
<script>
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "dz-list-group-item-noauth",
    components: {
    },
    props: {
        id: 0,
        
        //img: 0,
        sfid: 0,
        pbiid: 0,
    },
    data() {
        return {
            loading: true,
            meta: null,
            img: 0,
            url: '',
        };
    },
    methods: {
        delete_image(){
            swal.fire({
                title: 'delete this image?',
                html: '<div><img src="'+this.url+'"></div>',
                buttonsStyling: false,
                icon: 'question',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-info',
                confirmButtonText: 'Yes, delete!',
                cancelButtonClass: 'btn btn-secondary'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('deletePhotoBookImageNoAuth', { sfid: this.sfid, pbiid: this.img.id });
                    swal.fire({
                        title: 'Image deleted!',
                        timer: 1000,
                        icon: 'success',
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-success'
                    }).then((result) => {
                        this.$emit('image_deleted', this.img.id);
                        this.close();
                    });
                }
            })
        },
        close () {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },
        buildUrl(image){
            if (image && image.image && image.image.medium && image.image.medium.url) {
                let ht = this.$image_host + image.image.medium.url;
                console.log(ht);
                this.url = ht;
                return ht;
            } else {
                console.log("Image URL not ready yet");
                this.url = '';
                return '';
            }
        },
        retrievePhotoBookImage() {
            this.loading = true;
            this.$api.getSfPhotoBookImage(this.currentSnapWizard.id, this.id).then((response) => {
                console.log(response);
                this.img = response.data;

                // Check if image is still processing or meta is null
                if (this.img.meta == null || this.img.processing === true) {
                    console.log("adding settimeout - image still processing");
                    window.setTimeout( function() {
                        this.retrievePhotoBookImage();
                    }.bind(this), 2000); // Increased timeout to 2 seconds to reduce server load
                }
                else{
                    this.loading = false;
                    if (this.img.image && this.img.image.medium && this.img.image.medium.url) {
                        this.buildUrl(this.img);
                    }
                    if (this.img.meta) {
                        try {
                            this.meta = JSON.parse(this.img.meta);
                        } catch (e) {
                            console.warn("Failed to parse meta data:", e);
                        }
                    }
                }

            }).catch((e) => {
                console.log("Error fetching photo book image:", e);
                // Retry after a longer delay on error
                window.setTimeout( function() {
                    this.retrievePhotoBookImage();
                }.bind(this), 5000);
            }).finally(() => {
               // this.loading = false;

            });
        },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount', currentPhotoBook: 'currentPhotoBook', currentSnapWizard: 'currentSnapWizard' }),
        ...mapActions({ deletePhotoBookImage: 'deletePhotoBookImage' }),
    },
    created() {
        //this.meta = JSON.parse(this.img.meta);
    },
    mounted() {
      //  if(this.url == ''){
      //      this.ensurePhotoBookImage();
      //  }
        console.log("HID:"+this.id);
        this.retrievePhotoBookImage();
    },
};
</script>
<style scoped>
.loader{  /* Loader Div Class */
    position: absolute;
    top:0px;
    right:0px; 
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url(/img/custom/ajax-loader.gif);
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>